import React from "react"
import PropTypes from "prop-types"

import logo from "../images/logo.png"

const Footer = ({ siteTitle }) => (
  <footer>
    <div className="container">

      {/* <div>
        <strong style={{display:"block", fontSize: "24px",fontWeight:"bold"}}>Nazwa firmy</strong>
        <span style={{display:"block",fontSize: "18px"}}>
          email: 
          <a style={{textDecoration: "none", color:"black"}}
          href="mailto:biuro@szkolacoachingu.edu.pl">biuro@abcdefgh.edu.pl</a>
          </span>
        <a style={{display:"block", textDecoration: "none",fontSize: "18px", color:"black"}} href="tel:146510532">tel: (+48) 13 666 33 88</a>
      </div> */}

      <div id="footInfo">
        <img src={logo} alt="codex skup szkody" />
      </div>
      {/* <div>
        © {new Date().getFullYear()}
        {` `}
        {siteTitle}
      </div> */}
    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
